// const originalFetch = window.fetch;

// window.fetch = async (...args) => {
//   const response = await originalFetch(...args);

//   if (args[0]?.includes('/cart/change') || args[0]?.includes('/cart/update')) {
//     document.dispatchEvent(new CustomEvent("cart:quantity-change"));
//   }

//   return response;
// };

// document.addEventListener("cart:quantity-change", () => {
//   console.log("Cart quantity updated");

//   // ✅ Replace the entire footer section node so it fully reloads
//   if (section.id === "main-cart-footer") {
//     this.replaceSectionOuter(section.id, parsedState.sections[section.section]);
//     return;
//   }
// });

// replaceSectionOuter(sectionId, sectionHtml) {
//   const current = document.getElementById(sectionId);
//   if (!current) return;

//   const doc = new DOMParser().parseFromString(sectionHtml, "text/html");
//   const fresh = doc.getElementById(sectionId);
//   if (!fresh) return;

//   current.replaceWith(fresh);

//   // Hook for any JS that needs to re-init after footer replacement
//   document.dispatchEvent(
//     new CustomEvent("cart:section:replaced", {
//       detail: { id: sectionId },
//     }),
//   );
// }

const jpPublishAnalyticsEvent = (eventName, eventData) => {
  const analytics = window.Shopify?.analytics;
  if (typeof analytics?.publish !== 'function') return;

  try {
    const publication = analytics.publish(eventName, eventData);
    if (typeof publication?.catch === 'function') {
      publication.catch(() => {
        // Analytics must never interfere with storefront interactions.
      });
    }
  } catch {
    // Analytics must never interfere with storefront interactions.
  }
};

const jpFaqMetadata = (element) => {
  const faqItem = element.closest('collapsible-section[data-block-id]');
  const title = faqItem?.querySelector('.wt-collapse__trigger__title');
  const question = title?.textContent?.trim().replace(/\s+/g, ' ');

  if (!faqItem || !question) return null;

  return {
    faq_question: question,
    faq_id: faqItem.dataset.blockId,
    page_location: window.location.href,
    page_title: document.title,
  };
};

const jpGLightboxAssetElement = document.getElementById('jp-custom-script');
let jpGLightboxPromise;

const jpLoadGLightbox = () => {
  if (typeof window.GLightbox === 'function') {
    return Promise.resolve(window.GLightbox);
  }

  if (jpGLightboxPromise) return jpGLightboxPromise;

  const scriptUrl = jpGLightboxAssetElement?.dataset.jpGlightboxJs;
  const stylesheetUrl = jpGLightboxAssetElement?.dataset.jpGlightboxCss;

  if (!scriptUrl || !stylesheetUrl) {
    return Promise.reject(new Error('GLightbox asset URLs are unavailable.'));
  }

  const stylesheetPromise = new Promise((resolve, reject) => {
    const existingStylesheet = document.querySelector('[data-jp-glightbox-stylesheet]');
    if (existingStylesheet?.sheet) {
      resolve();
      return;
    }

    const stylesheet = existingStylesheet || document.createElement('link');
    stylesheet.addEventListener('load', resolve, { once: true });
    stylesheet.addEventListener(
      'error',
      () => reject(new Error('GLightbox stylesheet failed to load.')),
      { once: true },
    );

    if (!existingStylesheet) {
      stylesheet.rel = 'stylesheet';
      stylesheet.href = stylesheetUrl;
      stylesheet.dataset.jpGlightboxStylesheet = '';
      document.head.appendChild(stylesheet);
    }
  });

  const scriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector('[data-jp-glightbox-script]');
    if (existingScript && typeof window.GLightbox === 'function') {
      resolve(window.GLightbox);
      return;
    }

    const script = existingScript || document.createElement('script');
    script.addEventListener(
      'load',
      () => {
        if (typeof window.GLightbox === 'function') {
          resolve(window.GLightbox);
        } else {
          reject(new Error('GLightbox did not initialize after loading.'));
        }
      },
      { once: true },
    );
    script.addEventListener(
      'error',
      () => reject(new Error('GLightbox script failed to load.')),
      { once: true },
    );

    if (!existingScript) {
      script.src = scriptUrl;
      script.async = true;
      script.dataset.jpGlightboxScript = '';
      document.head.appendChild(script);
    }
  });

  jpGLightboxPromise = Promise.all([stylesheetPromise, scriptPromise])
    .then(([, GLightbox]) => GLightbox)
    .catch((error) => {
      jpGLightboxPromise = undefined;
      throw error;
    });

  return jpGLightboxPromise;
};

const jpAttachFaqVideoAnalytics = (lightbox, videoMetadata) => {
  lightbox.once('open', () => {
    jpPublishAnalyticsEvent('joshs_pickles:faq_video_open', videoMetadata);
  });

  lightbox.once('slide_after_load', ({ player, slideNode }) => {
    const media = player || slideNode?.querySelector('video');
    if (!media) return;

    const milestones = new Set();
    let started = false;
    let completed = false;

    const on = (eventName, handler) => {
      if (typeof media.on === 'function') {
        media.on(eventName, handler);
      } else if (typeof media.addEventListener === 'function') {
        media.addEventListener(eventName, handler);
      }
    };

    const publishStart = () => {
      if (started) return;
      started = true;
      jpPublishAnalyticsEvent('joshs_pickles:faq_video_start', videoMetadata);
    };

    on('play', publishStart);

    // GLightbox may autoplay before slide_after_load finishes. Plyr exposes
    // `playing`; native video exposes `paused`, so check both after binding.
    if (media.playing === true || media.paused === false) publishStart();

    on('timeupdate', () => {
      const duration = Number(media.duration);
      const currentTime = Number(media.currentTime);
      if (!Number.isFinite(duration) || duration <= 0 || !Number.isFinite(currentTime)) return;

      const percent = (currentTime / duration) * 100;
      [25, 50, 75].forEach((milestone) => {
        if (percent < milestone || milestones.has(milestone)) return;
        milestones.add(milestone);
        jpPublishAnalyticsEvent('joshs_pickles:faq_video_progress', {
          ...videoMetadata,
          video_percent: milestone,
        });
      });
    });

    on('ended', () => {
      if (completed) return;
      completed = true;
      jpPublishAnalyticsEvent('joshs_pickles:faq_video_complete', {
        ...videoMetadata,
        video_percent: 100,
      });
    });
  });
};

/**
 * Load the pinned GLightbox assets only when a Josh's Pickles video lightbox
 * is requested. This covers FAQ links and the packaging video rendered on the
 * homepage and collection templates without modifying Wonder components.
 */
document.addEventListener('click', async (event) => {
  const videoLink = event.target.closest(
    '.glightbox-vid, .wt-collapse-menu a[href*="cdn.shopify.com/videos"]',
  );
  if (!videoLink) return;

  event.preventDefault();

  try {
    const GLightbox = await jpLoadGLightbox();
    const faqMetadata = jpFaqMetadata(videoLink);
    const videoMetadata = faqMetadata
      ? {
          ...faqMetadata,
          video_url: videoLink.href,
          video_label: videoLink.textContent.trim().replace(/\s+/g, ' '),
        }
      : null;

    const lightbox = GLightbox({
      elements: [
        {
          href: videoLink.href,
          type: 'video',
          source: 'local',
        },
      ],
      touchNavigation: true,
      autoplayVideos: true,
    });

    if (videoMetadata) jpAttachFaqVideoAnalytics(lightbox, videoMetadata);

    lightbox.on('close', () => lightbox.destroy());
    lightbox.open();
  } catch (error) {
    console.error('Unable to open the video lightbox.', error);
    window.location.assign(videoLink.href);
  }
});

/**
 * Publish a Shopify customer event when an FAQ is opened.
 *
 * This deliberately lives outside Wonder's collapsible component so theme
 * upgrades can replace the component without mixing analytics code into the
 * vendor asset. It is scoped to the FAQ template so product and footer
 * accordions do not generate FAQ events.
 */
document.addEventListener('click', (event) => {
  if (!document.body.classList.contains('template-page-faq')) return;

  const trigger = event.target.closest('.wt-collapse__trigger');
  if (!trigger) return;

  const faqItem = trigger.closest('collapsible-section[data-block-id]');
  if (!faqItem) return;

  // Wonder updates data-open in its click handler. Defer one frame so we
  // publish only the resulting open state, not closes or failed toggles.
  window.requestAnimationFrame(() => {
    if (faqItem.dataset.open !== 'true') return;

    const faqMetadata = jpFaqMetadata(trigger);
    if (!faqMetadata) return;

    jpPublishAnalyticsEvent('joshs_pickles:faq_open', faqMetadata);
  });
});

// Explain why checkout is disabled when the cart is below the jar minimum.
let jpCheckoutMessageTimer;
document.addEventListener('click', (event) => {
  const guard = event.target.closest('[data-checkout-guard]');
  if (!guard) return;

  const jarsRemaining = Number.parseInt(guard.dataset.jarsRemaining || '0', 10);
  if (!Number.isFinite(jarsRemaining) || jarsRemaining <= 0) return;

  event.preventDefault();
  event.stopPropagation();

  const message = guard.querySelector('.checkout-disabled-message');
  if (!message) return;

  message.classList.add('is-visible');
  window.clearTimeout(jpCheckoutMessageTimer);
  jpCheckoutMessageTimer = window.setTimeout(() => message.classList.remove('is-visible'), 3000);
});
